import { FC, useCallback, useEffect, useMemo, useState } from "react";
import AppModal from "../../../apps/components/AppModal";
import { INotificationHistory, IProjectEvaluationListData } from "../../../project";
import EvalStatus from "../../../apps/components/EvalStatus";
import { useSnackbar } from "../../../../../_theme/context/SnackbarContext";
import { getEvaluatorReminderHistory, sendEvaluationReminderEmailsToAllEvaluators } from "../../../project/core/_project_evaluation";
import axios from "axios";
import Timeline from "../../../apps/components/Timeline";
import { CustomDateTimeFormate } from "../../../../../utils/date";
import CustomTable from "../../../../../_theme/widgets/tables/CustomTable";
interface Props {
  show: boolean;
  onClose: () => void;
  projectEvaluation: IProjectEvaluationListData;
}

const ProjectReminderLogModal: FC<Props> = ({
  show,
  onClose,
  projectEvaluation
}) => {
  const { showSnackbar } = useSnackbar();
  const [loading, setLoading] = useState<boolean>(false);
  const [reminderLog, setReminderLog] = useState<INotificationHistory[]>([]);
  const fetchReminderLog = useCallback(async () => {
    setLoading(true);
    try {
        const response = await getEvaluatorReminderHistory({project_id:projectEvaluation.project_id});
        if (response.status === 'ok') {
            setReminderLog(response.data);
        }else {
            showSnackbar(response.message, "danger");
        }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [projectEvaluation.project_id]);
  useEffect(() => {
    fetchReminderLog();
  }, [fetchReminderLog]);

  const columns = useMemo(() => [
    {
      header: "Name",
      accessorKey: "full_name",
    },
    {
      header: "Email",
      accessorKey: "email",
    },
    {
      header: "Sent On",
      accessorKey: "creation_date",
      cell: (info: { getValue: () => string }) => CustomDateTimeFormate(info.getValue()),
    },
  ], []);
  return (
    <AppModal
      show={show}
      title={`Reminder Log - ${projectEvaluation.project_name}`}
      onClose={onClose}
      showLoader={loading}
      loadingText={"Loading reminder log..."}
      width="800px"
      cancelText="Close"
    >
        <div className="d-flex flex-column">            
            <CustomTable data={reminderLog} columns={columns} hidePagination={reminderLog.length <= 10 ? true : false} />
        </div>
    </AppModal>
  );
};

export default ProjectReminderLogModal;